module.exports = __webpack_public_path__ + "static/img/4.ed2cd89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/4.jpg
// module id = c5iQ
// module chunks = 0